import { Box, Divider, Grid, Group, Paper, Text, UnstyledButton, useMantineTheme } from '@mantine/core';

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Companies } from '../components';
import PlansPage from "./plans";
import CouponsPage from "./coupons";
import AffiliatesPage from "./affiliates";
import Knowledges from "./knowledges";
import { useAuth } from '../contexts/auth.context';
import Appearance from './appearance';
import WLIntegrations from './whitelabel_integrations';
import WLUsersManagement from './wl_users_management';
import { useLanguage } from '../contexts/language.context';
import WLRetellKnowledgeBasesAudit from './wl_retell_knowledge_bases_audit';

export default function CompaniesPage(){
    const [selected, setSelected] = React.useState("companies");
    const { hash } = useLocation();
    const { str } = useLanguage();
    const { userData } = useAuth();
    const navigate = useNavigate();
    const theme = useMantineTheme();

    const options = [
        {key: "companies", title: str("WHITELABEL.COMPANIES") },
        (userData?.user?.isAdmin) && {key: "wl_plans", title: str("WHITELABEL.WL_PLANS") },
        (userData?.user?.isAdmin) && {key: "wl_users", title: str("WHITELABEL.WL_USERS") },
        (userData?.user?.whitelabelAdmin) && {key: "plans", title: str("WHITELABEL.PLANS") },
        (userData?.user?.whitelabelAdmin) && {key: "coupons", title: str("WHITELABEL.COUPONS") },
        (userData?.user?.whitelabelAdmin) && {key: "affiliates", title: str("WHITELABEL.AFFILIATES") },
        (userData?.user?.whitelabelAdmin) && {key: "appearance", title: str("WHITELABEL.APPEARANCE") },
        (userData?.user?.whitelabelAdmin) && {key: "connections", title: str("WHITELABEL.CONNECTIONS") },
        (userData?.user?.whitelabelAdmin) && {key: "retell_kb_audit", title: str("WHITELABEL.RETELL_KB_AUDIT") },
        // userData?.user?.isAdmin?.knowledges && {key: "knowledges", title: "Accelerator" },
        // userData?.user?.isAdmin?.blog_generator && {key: "blog_generator", title: "Blog Generator" },
    ].filter(nn => nn)

    React.useEffect(() => {
        if (hash) {
            setSelected(hash.split("#")[1]);
        }
      }, [hash])

    return <>
        <Paper shadow='xs' style={{padding: 0}}>
            <Grid gutter={0}>
                <Grid.Col span={{ base: 12, md: 3 }} style={{minHeight: '70vh'}}>
                    <Box style={{height: '100%'}}>
                        {options.map(({key, title}) => (
                            <UnstyledButton style={{width: '100%'}} onClick={() => navigate(`/whitelabel#${key}`)}>
                                <Group
                                    style={{borderRight: `7px solid ${selected === key ? "black" : "transparent"}`}}
                                    p="xl"
                                >
                                    <Box style={{flex: 1}}>
                                        <Text size="md" fw="bold" c="gray.0">{title}</Text>
                                    </Box>
                                </Group>
                                <Divider />
                            </UnstyledButton>
                        ))}
                    </Box>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 9 }} style={{height: '100%', minHeight: '80vh', backgroundColor: theme.colors.dark[9]}}>
                    <Box p="md" pr="xl">
                        {selected === "companies" && <Companies.List />}
                        {userData?.user?.whitelabelAdmin && selected === "plans" && <PlansPage />}
                        {userData?.user?.isAdmin && selected === "wl_plans" && <PlansPage whitelabel />}
                        {userData?.user?.isAdmin && selected === "wl_users" && <WLUsersManagement />}
                        {userData?.user?.whitelabelAdmin && selected === "coupons" && <CouponsPage />}
                        {userData?.user?.whitelabelAdmin && selected === "affiliates" && <AffiliatesPage />}
                        {userData?.user?.whitelabelAdmin && selected === "knowledges" && <Knowledges />}
                        {userData?.user?.whitelabelAdmin && selected === "appearance" && <Appearance />}
                        {userData?.user?.whitelabelAdmin && selected === "connections" && <WLIntegrations />}
                        {userData?.user?.whitelabelAdmin && selected === "retell_kb_audit" && <WLRetellKnowledgeBasesAudit />}
                    </Box>
                </Grid.Col>
            </Grid>
            </Paper>

    </>
    
}

